import { apiLoginUser } from './Consts';

export var userLoginAPI = (data) => {
    return fetch(apiLoginUser, {
            method: "POST",
            body: JSON.stringify(data),
            headers: { 
                'Content-Type': 'application/json' ,
                'Access-Control-Allow-Origin': 'http://localhost:3000',
                'Access-Control-Allow-Credentials': 'true'
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

